// @flow
import * as React from 'react';

import './styles/BottomContentWrapper.scss';

type Props = {|
    children: React.Node,
|};

function BottomContentWrapper({ children }: Props) {
    return <div className="BottomContentWrapper">{children}</div>;
}

export default BottomContentWrapper;
